<template>
    <v-list class="d-none d-md-flex flex-row flex-grow-0 mx-auto">
        <v-list-item
            class="justify-center"
            :to="{name: 'tech'}"
            :class="isCurrentTab('tech') ? 'selected' : ''">
            <v-list-item-icon>
                <v-icon>mdi-tune-vertical</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Compétences</v-list-item-content>
        </v-list-item>

        <v-list-item
            class="justify-center"
            :to="{name: 'xp'}"
            :class="isCurrentTab('xp') ? 'selected' : ''">
            <v-list-item-icon>
                <v-icon>mdi-briefcase-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Expériences</v-list-item-content>
        </v-list-item>

        <v-list-item
            class="justify-center"
            :to="{name: 'hobbies'}"
            :class="isCurrentTab('hobbies') ? 'selected' : ''">
            <v-list-item-icon>
                <v-icon>mdi-tennis</v-icon>
            </v-list-item-icon>
            <v-list-item-content>Hobbies</v-list-item-content>
        </v-list-item>

        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-list-item class="ml-12 justify-center" href="mailto:" target="_blank" ref="mailto" @click="mailto" v-on="on" v-bind="attrs">
                    <v-list-item-icon>
                        <v-icon>mdi-at</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </template>
            <span v-text="email" />
        </v-tooltip>

        <v-list-item class="justify-center" href="https://www.linkedin.com/in/david-ronsain-33416076/" target="_blank">
            <v-list-item-icon>
                <v-icon>mdi-linkedin</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-list-item class="justify-center" href="tel:" target="_blank" ref="tel" @click="tel" v-on="on" v-bind="attrs">
                    <v-list-item-icon>
                        <v-icon>mdi-phone</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </template>
            <span v-text="phone" />
        </v-tooltip>
    </v-list>
</template>

<script>
export default {
    name: 'desktopMenu'
}
</script>

<style scoped lang="scss">
@import '../../assets/css/variables.scss';

.v-list {
    background-color: $c-red !important;
    color: $c-white !important;

    &.d-md-flex {
        padding: 0 209px 0 16px !important;
    }

    .v-list-item {
        text-align: center;
        color: $c-white !important;
        font-weight: 600;

        .v-list-item__icon:first-child {
            margin-right: 0px !important;
        }

        .v-list-item__content {
            margin-left: 12px !important;
        }

        &--active:before, &--active:hover:before, &--active:focus:before, &--highlighted:before {
            opacity: 0 !important;
        }

        &.selected {
            border-bottom: 2px white solid !important;
        }
    }

    .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: $c-white !important;

        .v-icon {
            color: $c-white !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/desktopMenu.vue